var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-screen"},[_c('NavBar'),_c('v-container',[_c('VRow',{staticClass:"items-center",attrs:{"justify":"space-between"}},[_vm._t("contentHeader")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }